import { render, staticRenderFns } from "./notifications_type_setup.vue?vue&type=template&id=4322b93b&scoped=true&"
import script from "./notifications_type_setup.vue?vue&type=script&lang=js&"
export * from "./notifications_type_setup.vue?vue&type=script&lang=js&"
import style0 from "./notifications_type_setup.vue?vue&type=style&index=0&id=4322b93b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322b93b",
  null
  
)

export default component.exports